import { _ep0, _mw0, command } from "../commandBuilder";
import { GetUser$ } from "../schemas/schemas_0";
export class GetUserCommand extends command(_ep0, _mw0, "GetUser", GetUser$) {
}
